import React from 'react';
import PropTypes from 'prop-types';
import InputField from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';

const DiasParaVencimentoFilter = ({
  labelDias,
  labelDiasUteis,
  valueDias,
  valueUteis,
  onChangeDias,
  onChangeUteis,
  stackedLayout,
}) => {  
  const handleKeyDown = (e) => {
    // Bloqueia qualquer tecla que não seja número, se for um caractere imprimível (length === 1) e não for número, bloqueia
    if (e.key.length === 1 && isNaN(e.key)) {
      e.preventDefault();
    }
  };

  if (stackedLayout) {
    return (
      <div>
        <InputField
          type="number"
          min={1}
          step={1}
          onKeyDown={handleKeyDown}
          model={{
            label: labelDias,
            value: valueDias,
            requestChange: (novoValor) => {
              const parsed = parseInt(novoValor, 10);
              onChangeDias(isNaN(parsed) ? '' : parsed);
            },
          }}
        />
        <div style={{ marginTop: '0.75rem' }}>
          <Checkbox
            model={{
              label: labelDiasUteis,
              value: valueUteis === true,
              requestChange: (marcado) => onChangeUteis(marcado),
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center">
      <InputField
        type="number"
        min={1}
        step={1}
        onKeyDown={handleKeyDown}
        model={{
          label: labelDias,
          value: valueDias,
          requestChange: (novoValor) => {
            const parsed = parseInt(novoValor, 10);
            onChangeDias(isNaN(parsed) ? '' : parsed);
          },
        }}
      />

      <div style={{ marginLeft: '1rem' }}>
        <Checkbox
          model={{
            label: labelDiasUteis,
            value: valueUteis === true,
            requestChange: (marcado) => onChangeUteis(marcado),
          }}
        />
      </div>
    </div>
  );
};

DiasParaVencimentoFilter.propTypes = {
  labelDias: PropTypes.string.isRequired,
  labelDiasUteis: PropTypes.string.isRequired,
  valueDias: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueUteis: PropTypes.bool,
  onChangeDias: PropTypes.func.isRequired,
  onChangeUteis: PropTypes.func.isRequired,
  stackedLayout: PropTypes.bool,
};

DiasParaVencimentoFilter.defaultProps = {
  valueDias: '',
  valueUteis: false,
  stackedLayout: false,
};

export default DiasParaVencimentoFilter;
